<template>
<div>
<!--     <div class="vld-parent mycenter">
        <loading :active.sync="isLoading"
        :is-full-page="fullPage"></loading>
    </div>  -->

  <EpisodeList :episodes="episodes" v-if="episodes"/>
  <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>
  <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
      <ContentLoader v-if="!episodes && !mobileCheck"
      :height="900">
        <rect x="3" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="0" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="0" rx="3" ry="3" width="94" height="110" />
        
        <rect x="3" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="103" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="203" y="115" rx="3" ry="3" width="94" height="110" />
        <rect x="305" y="115" rx="3" ry="3" width="94" height="110" />        
      </ContentLoader> 

      <ContentLoader v-if="!popupDorms && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="376" height="800" />    
      </ContentLoader>
     
</div>
</template>

<script> 
import EpisodeList from '@/components/Season/EpisodeList'
import InfiniteLoading from 'vue-infinite-loading'
//import Loading from 'vue-loading-overlay'
import FixedPopup from '@/components/FixedPopup'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
export default {
  name: 'TVShowSeason', 
  components: {
    EpisodeList,
    InfiniteLoading,
    //Loading,
    FixedPopup,
    ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.cityDetails ? this.cityDetails.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.cityDetails ? this.cityDetails.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.cityDetails ? this.cityDetails.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath }
      ]
    }
  },
  data () {
    return {
      fullPath: '',
      url: '',
      isLoading: false,
      fullPage: true,
      page: 2,
      episodes: null,
      pagination: null,
      popupDorms: null,
      emptyContent: {
        icon: 'icon-search',
        title: 'No Results!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      }
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios
        .get(`/3/discover/tv?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&sort_by=popularity.desc&page=${this.page}&timezone=America%2FNew_York&with_networks=${this.$route.params.id}&include_null_first_air_dates=false`)
        .then(response => {
          if (response.data.results) {
            this.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (response.data.results.length !== 0) {
              response.data.results.forEach(item => {
                self.episodes.push(item)
              })
              // self.popupDorms = response.data.data.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    },
    getEpisodes () {
      let self = this
      this.isLoading = true
      const page = this.$route.params.page ? this.$route.params.page : 1
      axios.get(`/3/tv/${this.$route.params.id}/season/${this.$route.params.season}?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US`)
        .then(response => {
          // self.pagination = response.data.data
      //   self.$store.commit(SET_TOTAL_RESULTS, response.data.seasons.length)
      //    this.isLoading = false
          self.episodes = response.data.episodes
          //self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['cityDetails']),
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },        
  },
  mounted () {
    this.getEpisodes()
  },
  created() {
      this.getEpisodes()

    var myString = this.$route.fullPath
    var lastChar = myString[myString.length -1];
    
    if(lastChar === '/') {
        this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }    
  },
  watch: {
    $route () {
      this.getEpisodes()
      this.url = window.location.origin + this.$route.fullPath
    }
  }
}
</script>

<style scoped>
.mycenter {
 display:table;
 margin:0 auto;
}
</style>
